import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';

import SectionHeader from 'components/shared/landing/section-header';
import styles from './styles.module.scss';
import competencies, { targetedSkills } from 'utils/competency-data';
import EncyclopediaBreadcrumbs from './encyclopedia-breadcrumbs';

class Competency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectTo: false,
    };

    this.setRedirect = this.setRedirect.bind(this);
  }

  setRedirect(redirectTo) {
    return () => {
      this.setState({ redirectTo });
    };
  }

  render() {
    const { match } = this.props;
    const { redirectTo } = this.state;
    const { competency } = match.params;
    const selectedCompetency = competencies[competency];

    return (
      <div className={styles.encyclopediaContainer}>
        {redirectTo && <Redirect push to={`${match.url}/${redirectTo}`} />}
        <div className={styles.competencyHeader}>
          <div className="container">
            <div className="row">
              <div className="col-12 mb-4">
                <EncyclopediaBreadcrumbs
                  paths={[
                    { title: 'SEL Core Skills', link: '/sel-encyclopedia' },
                    { title: selectedCompetency.title },
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-7 order-2 order-md-1">
                <h1>{selectedCompetency.title}</h1>
                <p>{selectedCompetency.description}</p>
              </div>
              <div className="col-12 col-md-4 offset-md-1 order-1 order-md-2 mb-5 mb-md-0">
                <img src={selectedCompetency.icon} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  onClick={() => scrollToElement('#examples')}
                  className={styles.learnMore}
                >
                  <span>LEARN MORE</span>
                  <FontAwesomeIcon size="2x" fixedWidth icon="chevron-down" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="examples" className={styles.examples}>
          <div className="container">
            <SectionHeader
              tagline="Just some Examples"
              valueprop="Power Skills"
              subtext="Select a skill to find out more"
            />
            <div className="row mt-4">
              {selectedCompetency.targetedSkills.map(skill => (
                <div key={skill.link} className="col-12 col-lg-4 mb-5 mb-lg-0">
                  <div
                    className={styles.targetedSkill}
                    onClick={this.setRedirect(skill.link)}
                  >
                    <div className={styles.icon}>
                      <img src={targetedSkills[skill.link].icon} />
                    </div>
                    <h5>{skill.title}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Competency;
